import { PermissionCode } from '@core-frontend/core-frontend';
import { lazy } from 'react';

import { AppRoutes } from '../AppRoutes';
import type { RouteProtectedWithPermissionObject } from '../types';

const UserAccountsPage = lazy(() =>
  import('@/pages/user').then((module) => ({
    default: module.UserAccountsPage,
  }))
);

const UserAccountDetailsPage = lazy(() =>
  import('@/pages/user').then((module) => ({
    default: module.UserAccountDetailsPage,
  }))
);

const UserProfileDetailsPage = lazy(() =>
  import('@/pages/profile').then((module) => ({
    default: module.UserProfileDetailsPage,
  }))
);

const UserChangePasswordPage = lazy(() =>
  import('@/pages/profile').then((module) => ({
    default: module.UserProfileDetailsPage,
  }))
);

const UserCreateManagedPage = lazy(() =>
  import('@/pages/profile').then((module) => ({
    default: module.UserCreateManagedPage,
  }))
);

export const userRouter: RouteProtectedWithPermissionObject[] = [
  {
    path: AppRoutes.USER_ACCOUNTS,
    element: <UserAccountsPage />,
    permissions: [PermissionCode.VIEW_USERS],
  },
  {
    path: AppRoutes.USER_ACCOUNT_DETAILS,
    element: <UserAccountDetailsPage />,
  },
  {
    path: AppRoutes.USER_PROFILE_DETAILS,
    element: <UserProfileDetailsPage />,
  },
  {
    path: AppRoutes.CHANGE_PASSWORD,
    element: <UserChangePasswordPage />,
  },
  {
    path: AppRoutes.USER_MANAGED_CREATE,
    element: <UserCreateManagedPage />,
  },
];
